<template>
  <content-with-loading-skeleton
    :isLoading="isLoadingAndNotReloading"
    loadingMessage="Loading Media Data..."
    :isWithMessage="true"
  >
    <template #loaded>
      <ImageOrVideoEditor v-if="data.assetType == 'image' || data.assetType == 'video'" :isReadOnly="isReadOnly" />
      <SlideEditor v-else-if="data.assetType == 'slide'" :isReadOnly="isReadOnly" />
    </template>
  </content-with-loading-skeleton>
</template>

<script lang="ts" setup>
import SlideEditor from './SlideEditor/SlideEditor.vue';
import ImageOrVideoEditor from './ImageOrVideoEditor/ImageOrVideoEditor.vue';

import useMediaItem from './composables/mediaItem';
import useUser from '@/composables/user';

import { computed, onMounted, provide } from 'vue';
import { useRoute } from 'vue-router';

const route = useRoute();
const id = computed(() => route.params.id as string);
const user = useUser();
const isReadOnly = computed(() => !user.hasWriteAccessToArea('MediaLibrary'));

const { loadMediaItem, data, isLoading, isReloading } = useMediaItem();

provide('isReadOnly', isReadOnly);

onMounted(() => {
  loadMediaItem(id.value);
});

const isLoadingAndNotReloading = computed(()=> (isLoading.value && !isReloading.value))
</script>

<style lang="scss" scoped>

</style>